import { Button, Group, Paper, SimpleGrid, Stack } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { useForm } from '@mantine/form';
import PageViewProperty from '../../../../components/core/PageViewProperty/PageViewProperty';
import { ContractSearchResponseType, ContractType } from '../../../../models/core/contracts.type';
import { fnsFormatDate, formatDateStringToDate, formatDateToString } from '../../../../utils/formatter.utils';
import { tryGetDateISOFormat } from '../../../../utils/helper.utils';

type ContractExtendModalContentProps = {
  item: Pick<
    ContractSearchResponseType | ContractType,
    'idContrato' | 'dataFinal' | 'clienteNomeFantasia' | 'clienteRazaoSocial' | 'clienteNome'
  >;
  onCancel(): void;
  onConfirm(value: string): void;
};

type FormData = {
  dataFinal: Date | null;
};

export default function ContractExtendModalContent({
  item,
  onCancel,
  onConfirm,
}: Readonly<ContractExtendModalContentProps>) {
  const currentFinalDate = new Date(item.dataFinal);
  const minDate = formatDateStringToDate(tryGetDateISOFormat(item.dataFinal));
  minDate.setDate(minDate.getDate() + 1);

  const form = useForm<FormData>({
    initialValues: {
      dataFinal: null,
    },
    validate: {
      dataFinal: (value) => {
        if (!value) {
          return 'Campo obrigatório.';
        }

        if (value <= currentFinalDate) {
          return 'Nova Data Final deve ser pelo menos 1 dia após a data final atual.';
        }

        return null;
      },
    },
  });

  return (
    <Stack>
      <Paper shadow="xs" p="md" withBorder>
        <SimpleGrid cols={3}>
          <PageViewProperty label="#" text={item.idContrato.toString()} size="sm" />
          <PageViewProperty
            label="Data Final Atual"
            text={formatDateToString(new Date(item.dataFinal))}
            size="sm"
          />
          <PageViewProperty
            label="Cliente"
            text={item.clienteNomeFantasia || item.clienteRazaoSocial || item.clienteNome || '-'}
            size="sm"
          />
        </SimpleGrid>
      </Paper>
      <DateInput
        label="Nova Data Final"
        placeholder="Selecione a nova data final"
        minDate={minDate}
        clearable={false}
        required
        {...form.getInputProps('dataFinal')}
      />
      <Group justify="flex-end">
        <Button variant="outline" onClick={onCancel}>
          Fechar
        </Button>
        <Button
          onClick={() => {
            const validation = form.validate();
            if (!validation.hasErrors && form.values.dataFinal) {
              onConfirm(fnsFormatDate(form.values.dataFinal, 'yyyy-MM-dd'));
            }
          }}
        >
          Prorrogar
        </Button>
      </Group>
    </Stack>
  );
}
